import React from 'react';
import {connect} from 'react-redux';
import {deleteSshkey,cancelSshkey} from '../store/sshkeyActions'

const ConfirmDelete = ({keyToDelete,deleteSshkey,cancelSshkey}) => {
  const onConfirm = () => deleteSshkey({sshkey:keyToDelete});
  const onCancel = () => cancelSshkey();

  return (
    <>
      <div id='modal1' className='modal'>
        <div className='modal-content'>
          <h6>Confirm deletion?</h6>
        </div>
        <div className='modal-footer'>
          <a href='#!' className='modal-close waves-effect waves-red btn-flat' onClick={onConfirm}>Confirm</a>
          <a href='#!' className='modal-close waves-effect waves-green btn-flat' onClick={onCancel}>Cancel</a>
        </div>
      </div>
    </>
  )
};

const mapStoreToProps = state => ({
  keyToDelete: state.sshkey.keyToDelete
});

export default connect(mapStoreToProps,{deleteSshkey,cancelSshkey})(ConfirmDelete)
